import { ModalWrapper } from 'src/components/modal-wrapper'
import { ExposePrivateKey } from './expose-private-key.component'

import { useStyles } from '../user-profile/change-password-modal/styles'
import { PrivateKeyRequestFn, PrivateKeyVerifyFn } from 'src/types'

interface IExposePrivateKeyModalProps {
  handleClose: () => void
  open: boolean
  requestFn: PrivateKeyRequestFn
  verifyFn: PrivateKeyVerifyFn
}

const ExposePrivateKeyModal = ({
  handleClose,
  open,
  requestFn,
  verifyFn,
}: IExposePrivateKeyModalProps) => {
  const classes = useStyles()

  return (
    <ModalWrapper open={open} onClose={handleClose} className={classes.modalWrapper}>
      <ExposePrivateKey requestFn={requestFn} verifyFn={verifyFn} />
    </ModalWrapper>
  )
}

export { ExposePrivateKeyModal }
